"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }// src/english-grades/english-converter.ts
var ENGLISH_TESTING_TYPES = ["ielts", "toefl", "pte", "duolingo_english_test", "duolingo"];
var isEnglishTestingType = (type) => ENGLISH_TESTING_TYPES.includes(type);
var EnglishConverter = class {
  static toArray(resume) {
    return ENGLISH_TESTING_TYPES.map((type) => {
      const typeObj = resume[`${type}_test_score`];
      if (typeObj) return { type, ...typeObj };
      const total = resume[`${type}`] || null;
      const listening = resume[`${type}_listening`] || null;
      const reading = resume[`${type}_reading`] || null;
      const writing = resume[`${type}_writing`] || null;
      const speaking = resume[`${type}_speaking`] || null;
      return { type, total, listening, reading, writing, speaking };
    });
  }
  static toValidArray(resume) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }
  static toObject(items) {
    const resume = {};
    items.forEach((item) => {
      const { type, total, listening, reading, writing, speaking } = item;
      resume[`${type}`] = total;
      resume[`${type}_listening`] = listening;
      resume[`${type}_reading`] = reading;
      resume[`${type}_writing`] = writing;
      resume[`${type}_speaking`] = speaking;
      resume[`${type}_test_score`] = {
        total,
        listening,
        reading,
        writing,
        speaking
      };
    });
    return resume;
  }
  static defaults() {
    return {
      toefl: null,
      pte: null,
      ielts: null,
      duolingo_english_test: null,
      toefl_listening: null,
      toefl_reading: null,
      toefl_writing: null,
      toefl_speaking: null,
      pte_listening: null,
      pte_reading: null,
      pte_writing: null,
      pte_speaking: null,
      ielts_listening: null,
      ielts_reading: null,
      ielts_writing: null,
      ielts_speaking: null,
      duolingo_english_test_listening: null,
      duolingo_english_test_reading: null,
      duolingo_english_test_writing: null,
      duolingo_english_test_speaking: null,
      // new version[toefl_test_score/pte_score/ielts_score/duolingo_english_test_score]
      toefl_test_score: {
        total: null,
        listening: null,
        reading: null,
        writing: null,
        speaking: null
      },
      pte_test_score: {
        total: null,
        listening: null,
        reading: null,
        writing: null,
        speaking: null
      },
      ielts_test_score: {
        total: null,
        listening: null,
        reading: null,
        writing: null,
        speaking: null
      },
      duolingo_test_score: {
        total: null,
        listening: null,
        reading: null,
        writing: null,
        speaking: null
      }
    };
  }
};
EnglishConverter.is = isEnglishTestingType;
EnglishConverter.isValid = (item) => {
  return item.total > 0 || item.listening > 0 || item.reading > 0 || item.writing > 0 || item.speaking > 0;
};

// src/english-grades/gre-converter.ts
var GRE_TESTING_TYPES = ["gre"];
var isGreTestingType = (type) => GRE_TESTING_TYPES.includes(type);
var _GreConverter = class _GreConverter {
  static toArray(resume) {
    return GRE_TESTING_TYPES.map((type) => {
      const typeObj = resume[`${type}_test_score`];
      if (typeObj) return { type, ...typeObj };
      const total = resume[`${type}`] || null;
      const verbal = resume[`${type}_verbal`] || null;
      const quantitative = resume[`${type}_quantitative`] || null;
      return { type, total, verbal, quantitative };
    });
  }
  static toValidArray(resume) {
    const items = this.toArray(resume);
    return items.filter(_GreConverter.isValid);
  }
  static toObject(items) {
    const resume = {};
    items.forEach((item) => {
      const { type, total, verbal, quantitative } = item;
      resume[`${type}`] = total;
      resume[`${type}_verbal`] = verbal;
      resume[`${type}_quantitative`] = quantitative;
      resume[`${type}_test_score`] = {
        total,
        verbal,
        quantitative
      };
    });
    return resume;
  }
  static defaults() {
    return {
      gre: null,
      gre_verbal: null,
      gre_quantitative: null,
      // v2 version
      gre_test_score: {
        total: null,
        verbal: null,
        quantitative: null
      }
    };
  }
};
_GreConverter.is = isGreTestingType;
_GreConverter.isValid = (item) => {
  return item.total > 0 || item.verbal > 0 || item.quantitative > 0;
};
var GreConverter = _GreConverter;

// src/english-grades/gmat-converter.ts
var GMAT_TESTING_TYPES = ["gmat"];
var isGmatTestingType = (type) => GMAT_TESTING_TYPES.includes(type);
var GmatConverter = class {
  static toArray(resume) {
    return GMAT_TESTING_TYPES.map((type) => {
      const typeObj = resume[`${type}_test_score`];
      if (typeObj) return { type, ...typeObj };
      return {
        type,
        total: resume[type] || null,
        quant: resume[`${type}_quant`] || null,
        data_insights: resume[`${type}_data_insights`] || null
      };
    });
  }
  static toValidArray(resume) {
    return this.toArray(resume).filter(this.isValid);
  }
  static toObject(items) {
    const resume = {};
    items.forEach((item) => {
      const { type, total, quant, data_insights, verbal } = item;
      resume[type] = total;
      resume[`${type}_quant`] = quant;
      resume[`${type}_data_insights`] = data_insights;
      resume[`${type}_verbal`] = verbal;
      resume[`${type}_test_score`] = {
        total,
        quant,
        data_insights,
        verbal
      };
    });
    return resume;
  }
  static defaults() {
    return {
      gmat: null,
      gmat_quant: null,
      gmat_data_insights: null,
      gmat_verbal: null,
      // v2
      gmat_test_score: {
        total: null,
        quant: null,
        data_insights: null,
        verbal: null
      }
    };
  }
};
GmatConverter.is = isGmatTestingType;
GmatConverter.isValid = (item) => {
  return item.total > 0 || item.quant > 0 || item.data_insights > 0 || item.verbal > 0;
};

// src/standardized-grades/act-converter.ts
var ACT_TESTING_TYPES = ["act"];
var isSat = (type) => ACT_TESTING_TYPES.includes(type);
var SatConverter = class {
  static toArray(resume) {
    return ACT_TESTING_TYPES.map((type) => {
      return {
        type,
        ...resume["act_test_score"]
      };
    });
  }
  static toValidArray(resume) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }
  static toObject(items) {
    const resume = {};
    items.forEach((item) => {
      if (this.is(item.type)) {
        resume["act_test_score"] = item;
      }
    });
    return resume;
  }
  static toObjectV3(obj) {
    const resume = {};
    resume["act_test_score"] = {
      type: "act",
      ...obj
    };
    return resume;
  }
  static defaults() {
    return {
      act_test_score: {
        total: 0,
        reading: 0,
        english: 0,
        math: 0,
        science: 0,
        writing: 0
      }
    };
  }
};
SatConverter.is = isSat;
SatConverter.isValid = (item) => {
  return item.total > 0 || item.reading > 0 || item.english > 0 || item.math > 0 || item.science > 0 || item.writing > 0;
};

// src/standardized-grades/sat-converter.ts
var SAT_TESTING_TYPES = ["sat"];
var isSat2 = (type) => SAT_TESTING_TYPES.includes(type);
var SatConverter2 = class {
  static toArray(resume) {
    return SAT_TESTING_TYPES.map((type) => {
      return {
        type,
        ...resume["sat_i_test_score"]
      };
    }).filter(Boolean);
  }
  static toValidArray(resume) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }
  static toObject(items) {
    const resume = {};
    items.forEach((item) => {
      if (this.is(item.type)) {
        resume["sat_i_test_score"] = item;
      }
    });
    return resume;
  }
  static toObjectV3(obj) {
    const resume = {};
    resume["sat_i_test_score"] = {
      type: "sat",
      ...obj
    };
    return resume;
  }
  static defaults() {
    return {
      sat_i_test_score: {
        total: 0,
        reading_and_writing: 0,
        math: 0
      }
    };
  }
};
SatConverter2.is = isSat2;
SatConverter2.isValid = (item) => {
  return item.total > 0 || item.reading_and_writing > 0 || item.math > 0;
};

// src/standardized-grades/ap-tests-converter.ts
var SUBJECT_TESTING_TYPES = ["ap"];
var isSubjectTests = (type) => SUBJECT_TESTING_TYPES.includes(type);
var ApTestsConverter = class {
  static toArray(resume) {
    const items = [];
    SUBJECT_TESTING_TYPES.forEach((type) => {
      const subjectTests = resume["ap_subject_tests"] || [];
      subjectTests.forEach((subjectTest) => {
        const { score, subject } = subjectTest;
        items.push({ type, score, subject });
      });
    });
    return items;
  }
  static toValidArray(resume) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }
  static toObject(items) {
    const results = items.map((item) => {
      const { score, subject } = item;
      return { score: score || 0, subject: subject || "" };
    });
    return {
      ap_subject_tests: results
    };
  }
  static defaults() {
    return {
      ap_subject_tests: []
    };
  }
};
ApTestsConverter.is = isSubjectTests;
ApTestsConverter.isValid = (item) => {
  return item.score > 0 || Boolean(item.subject);
};

// src/standardized-grades/ib-subject-test-converter.ts
var IB_TESTES = ["ib"];
var isSat3 = (type) => IB_TESTES.includes(type);
var IbSubjectTestConverter = class {
  static toArray(resume) {
    return IB_TESTES.map((type) => {
      const target = resume["ib_subject_test"];
      if (!target) return null;
      return { type, ...target };
    }).filter(Boolean);
  }
  static toValidArray(resume) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }
  static toObject(items) {
    const resume = {};
    items.forEach((item) => {
      if (this.is(item.type)) {
        resume["ib_subject_test"] = item;
      }
    });
    return resume;
  }
  static toObjectV3(obj) {
    const resume = {};
    resume["ib_subject_test"] = {
      type: "ib",
      ...obj
    };
    return resume;
  }
  static defaults() {
    return {
      ib_subject_test: {
        type: "ib",
        study_in_language_and_literature: 0,
        language_acquisition: 0,
        individuals_and_societies: 0,
        experimental_science: 0,
        mathematics: 0,
        the_arts: 0
      }
    };
  }
};
IbSubjectTestConverter.is = isSat3;
IbSubjectTestConverter.isValid = (item) => {
  return item.type === "ib" && item.study_in_language_and_literature > 0 && item.language_acquisition > 0 && item.individuals_and_societies > 0 && item.experimental_science > 0 && item.mathematics > 0 && item.the_arts > 0;
};

// src/standardized-grades/a-level-subject-tests-converter.ts
var SUBJECT_TESTING_TYPES2 = ["a_level"];
var isALevelSubjectTests = (type) => SUBJECT_TESTING_TYPES2.includes(type);
var SubjectTestsConverter = class {
  static toArray(resume) {
    const items = [];
    SUBJECT_TESTING_TYPES2.forEach((type) => {
      const subjectTests = resume[`${type}_subject_tests`] || [];
      subjectTests.forEach((subjectTest) => {
        const { subject, examination_board, level } = subjectTest;
        items.push({ type, subject, examination_board, level });
      });
    });
    return items;
  }
  static toValidArray(resume) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }
  static toObject(items) {
    const resume = {};
    items.forEach((item) => {
      const { type, subject, examination_board, level } = item;
      const subjectTests = resume[`${type}_subject_tests`] || [];
      subjectTests.push({
        subject: subject || "",
        examination_board: examination_board || "",
        level
      });
      resume[`${type}_subject_tests`] = subjectTests;
    });
    return resume;
  }
  static defaults() {
    return {
      a_level_subject_tests: []
    };
  }
};
SubjectTestsConverter.is = isALevelSubjectTests;
SubjectTestsConverter.isValid = (item) => {
  return Boolean(item.subject) || Boolean(item.examination_board) || Boolean(item.level);
};

// src/resume/helper.ts
var ResumeHelper = class {
  static getDefaults() {
    return {
      // common fields
      gpa: null,
      gpa_raw: null,
      gpa_raw_scale: null,
      class_rank: null,
      high_school: "",
      high_school_grade_level: null,
      summer_school_or_exchange_programs: [],
      courses: [],
      undergraduate_courses: [],
      honors: [],
      papers: [],
      extracurricular_activities: [],
      name: "",
      languages: [],
      interested_career_or_major: "",
      specialties_and_certifications: [],
      patents: [],
      target_countries_or_regions: [],
      interested_majors: [],
      preference_tags: {},
      // new undergraduate fields
      internship_and_work_experiences: [],
      research_and_project_experiences: [],
      honors_and_awards: [],
      other_specialties_activities_experiences: []
    };
  }
};
var helper_default = ResumeHelper;

// src/resume/region-tags.ts
var _treeutils = require('@jswork/tree-utils');
var TREE_OPTS = { children: "data" };
var RegionTags = class {
  static toArray(options) {
    const { region_tags, preference_tags } = options;
    const result = [];
    for (const region in preference_tags) {
      for (const type in preference_tags[region]) {
        for (const key in preference_tags[region][type]) {
          const value = preference_tags[region][type][key];
          const keyItem = _treeutils.findItem.call(void 0, region_tags, key, TREE_OPTS);
          const valueItems = _treeutils.findItems.call(void 0, region_tags, value, TREE_OPTS);
          if (valueItems.length) {
            result.push({
              region,
              type,
              key: _optionalChain([keyItem, 'optionalAccess', _ => _.label]),
              value: valueItems.map((v) => v.label).join(", ")
            });
          }
        }
      }
    }
    return result;
  }
};
var region_tags_default = RegionTags;

// src/profile/helper.ts
var ProfileHelper = class {
  static getDefaults() {
    return {
      name: "",
      city: ""
    };
  }
};
var helper_default2 = ProfileHelper;

// src/standardized-grades/converter-manager.ts
var ConverterManager = class {
  static getConverter(type) {
    if (SubjectTestsConverter.is(type)) return SubjectTestsConverter;
    if (SatConverter.is(type)) return SatConverter;
    if (ApTestsConverter.is(type)) return ApTestsConverter;
    if (SatConverter2.is(type)) return SatConverter2;
  }
  static defaults() {
    return {
      ...SubjectTestsConverter.defaults(),
      ...SatConverter.defaults(),
      ...ApTestsConverter.defaults(),
      ...SatConverter2.defaults()
    };
  }
};

// src/english-grades/minmax.ts
var _next = require('@jswork/next'); var _next2 = _interopRequireDefault(_next);
var dlgConfig = {
  total: { min: 40, max: 160 },
  listening: { min: 10, max: 160 },
  reading: { min: 10, max: 160 },
  writing: { min: 10, max: 160 },
  speaking: { min: 10, max: 160 }
};
var defaults = {
  toefl: {
    total: { min: 0, max: 120 },
    listening: { min: 0, max: 30 },
    reading: { min: 0, max: 30 },
    writing: { min: 0, max: 30 },
    speaking: { min: 0, max: 30 }
  },
  ielts: {
    total: { min: 4, max: 9 },
    listening: { min: 4, max: 9 },
    reading: { min: 4, max: 9 },
    writing: { min: 4, max: 9 },
    speaking: { min: 4, max: 9 }
  },
  gre: {
    total: { min: 260, max: 340 },
    verbal: { min: 130, max: 170 },
    quantitative: { min: 130, max: 170 }
  },
  gmat: {
    total: { min: 205, max: 805 },
    verbal: { min: 60, max: 90 },
    quant: { min: 60, max: 90 },
    data_insights: { min: 60, max: 90 }
  },
  pte: {
    total: { min: 20, max: 90 },
    listening: { min: 20, max: 90 },
    reading: { min: 20, max: 90 },
    writing: { min: 20, max: 90 },
    speaking: { min: 20, max: 90 }
  },
  duolingo: dlgConfig,
  // 冗余兼容设计
  duolingo_english_test: dlgConfig
};
var minmax_default = (type, field) => {
  return _next2.default.get(defaults, `${type}.${field}`);
};

// src/english-grades/en-step.ts
var en_step_default = (model) => {
  if (!_optionalChain([model, 'optionalAccess', _2 => _2.type])) return 1;
  return _optionalChain([model, 'optionalAccess', _3 => _3.type]) === "ielts" ? 0.1 : 1;
};

// src/standardized-grades/minmax.ts

var defaults2 = {
  sat: {
    total: { min: 400, max: 1600 },
    reading_and_writing: { min: 200, max: 800 },
    math: { min: 200, max: 800 }
  },
  act: {
    total: { min: 1, max: 36 },
    english: { min: 1, max: 36 },
    math: { min: 1, max: 36 },
    reading: { min: 1, max: 36 },
    science: { min: 1, max: 36 },
    writing: { min: 1, max: 36 }
  },
  ap: {
    score: { min: 1, max: 5 }
  },
  ib: {
    total: { min: 0, max: 45 },
    studies_in_language_and_literature: { min: 0, max: 7 },
    language_acquisition: { min: 0, max: 7 },
    individuals_and_societies: { min: 0, max: 7 },
    experimental_science: { min: 0, max: 7 },
    mathematics: { min: 0, max: 7 },
    the_arts: { min: 0, max: 7 }
  }
};
var minmax_default2 = (type, field) => {
  return _next2.default.get(defaults2, `${type}.${field}`);
};
















exports.ALevelSubjectTestsConverter = SubjectTestsConverter; exports.ActConverter = SatConverter; exports.ApTestsConverter = ApTestsConverter; exports.EnglishConverter = EnglishConverter; exports.GmatConverter = GmatConverter; exports.GreConverter = GreConverter; exports.IbSubjectTestConverter = IbSubjectTestConverter; exports.ProfileHelper = helper_default2; exports.RegionTags = region_tags_default; exports.ResumeHelper = helper_default; exports.SatConverter = SatConverter2; exports.StandardizedGradeManager = ConverterManager; exports.enStep = en_step_default; exports.minmax = minmax_default; exports.stdMinMax = minmax_default2;
